import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { closeCustomModal, openCustomModal } from "views/lib/components/modals";
import { getList, getFilters } from "actions/phone-codes/actions";
import filterCaseInsensitive from "helpers/react-table-case-insensitive";
import ReactTable from "react-table";
import Filters from "./filters";
import CreateModal from "./create-modal";

const NotificationTemplates = ({
                                 getList,
                                 // deleteTemplate,
                                 list,
                                 loading,
                                 closeCustomModal,
                                 openCustomModal
                               }) => {
  const handleCreate = (id = false) => {
    const modalObj = {
      modalSettings: {
        size: "lg",
        style: {
          width: 1200,
          maxWidth: "100%",
          padding: 20
        }
      },
      header: "Phone Codes",
      children: (
        <CreateModal
          onCancel={() => closeCustomModal(modalObj)}
          id={id}
        />
      ),
      handleClose: () => closeCustomModal(modalObj)
    };
    openCustomModal(modalObj);
  };

  /* const handleDelete = (id) => {
    deleteTemplate(id);
  }; */

  const getColumns = () => [
    {
      Header: "#",
      accessor: "id",
    },
    {
      Header: "Code",
      accessor: "code",
    },
    {
      Header: "Flag",
      accessor: "flag",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => <img alt={original.code} src={`data:image/png;base64,${original.flag}`} height={24} style={{ width: "auto" }} />
    },
    {
      id: "actions",
      Header: "Actions",
      className: "text-center",
      headerClassName: "text-center",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <React.Fragment>
          {console.log("original", original)}
          {/* <button
            className="btn btn-sm btn-warning mr-3"
            onClick={() => handleCreate(original.id)}
          >
            <FontAwesomeIcon icon={faPencilAlt}/>
          </button> */}
         {/*  <Popconfirm
            title="Are you sure?"
            onConfirm={() => handleDelete(original.id)}
            placement="bottomRight"
            okText="Yes"
            cancelText="Cancel"
          >
            <button className="btn btn-sm btn-danger">
              <FontAwesomeIcon icon={faTimes}/>
            </button>
          </Popconfirm> */}
        </React.Fragment>
      )
    },
  ];

  useEffect(() => {
    getList();
  }, []);

  return (
    <div className="w-100 p-2">
      <Filters
        handleCreate={() => handleCreate()}
        totalCount={list.length}
      />
      <ReactTable
        data={list}
        headerClassName="table-header"
        columns={getColumns()}
        pageSizeOptions={[10, 20, 50, 100]}
        resizable
        className="-striped -highlight table-header-padding"
        loading={loading}
        filterable={false}
        defaultFilterMethod={filterCaseInsensitive}
        style={{
          height: "calc(100vh - 140px)"
        }}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  loading: state.phoneCodes.loading,
  list: state.phoneCodes.list,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
  getList: bindActionCreators(getList, dispatch),
  getFilters: bindActionCreators(getFilters, dispatch)
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(NotificationTemplates);



// WEBPACK FOOTER //
// ./src/views/pages/phone-codes/index.js